import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://bloomerslkn.com";
const DEFAULT_IMAGE = `${SITE}/og-image.png`;

/**
 * Renders <title>, meta description, canonical, Open Graph, Twitter Card and
 * an optional JSON-LD block for a given page.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  jsonLd = null,
}) {
  const fullTitle = title
    ? `${title} · Bloomers — Inspired Plantscapes`
    : "Bloomers — Inspired Plantscapes · Lake Norman Landscape Design";
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content="Bloomers — Inspired Plantscapes" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
